(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muja-event-enquiry"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.muja-event').forEach((section) => {
  const experience = section.querySelector('[data-muja-experience]');
  if (!experience) return;
  experience.addEventListener('change', () => {
    const guided = ['Misbah Making', 'Bead Creations'].includes(experience.value);
    const hosted = ['Misbah Customisation', 'Custom Bracelet Bar'].includes(experience.value);
    const format = guided ? 'guided' : hosted ? 'hosted' : null;
    if (format) section.querySelector('[data-muja-format="' + format + '"]').checked = true;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muja-national-day-video"] && !Shopify.designMode) return;
  try {
    
function initMujaWelcome(root){if(root.dataset.initialized)return;root.dataset.initialized='true';const video=root.querySelector('video');const button=root.querySelector('[data-video-toggle]');const mobile=window.matchMedia('(max-width:749px)');const motion=window.matchMedia('(prefers-reduced-motion:reduce)');const connection=navigator.connection;function label(){button.textContent=video.paused?button.dataset.play:button.dataset.pause;}function ensureSource(){const src=mobile.matches?video.dataset.mobileSrc:video.dataset.desktopSrc;if(src&&video.getAttribute('src')!==src){video.src=src;video.load();}video.muted=true;}function reset(){video.pause();if(mobile.matches||motion.matches||(connection&&connection.saveData)){video.removeAttribute('src');video.load();}else{ensureSource();video.play().catch(label);}button.hidden=false;label();}button.addEventListener('click',()=>{if(video.paused){ensureSource();video.play().catch(label);}else video.pause();});video.addEventListener('play',label);video.addEventListener('pause',label);mobile.addEventListener('change',reset);motion.addEventListener('change',reset);reset();}document.querySelectorAll('[data-muja-welcome]').forEach(initMujaWelcome);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-muja-welcome]').forEach(initMujaWelcome));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muja-workshop-cards"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('muja-media-carousel')) {
  customElements.define('muja-media-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.muja-media-track');
      const slides = Array.from(track.children);
      const previous = this.querySelector('[data-media-prev]');
      const next = this.querySelector('[data-media-next]');
      const count = this.querySelector('[data-media-current]');
      this.querySelector('[data-media-total]').textContent = slides.length;
      const index = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
      const update = () => {
        const current = index();
        count.textContent = current + 1;
        previous.disabled = current === 0;
        next.disabled = current === slides.length - 1;
        slides.forEach((slide, i) => {
          const video = slide.querySelector('video');
          if (video && i !== current) video.pause();
        });
      };
      const move = (step) => {
        const target = Math.max(0, Math.min(slides.length - 1, index() + step));
        track.scrollTo({ left: target * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      if (slides.length < 2) this.querySelector('.muja-media-controls').hidden = true;
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
